<template lang="pug">
	.related-properties(v-if="relatedProperties.length == 3")
		h3.related-properties__title {{$t('AADAT.similarTitle')}}
		.related-properties__wrapper
			ResultCard(v-for="result in relatedProperties" :result="result", :key="result.comissionId")
</template>
<script>
import ResultCard from '../../common/components/result-card/result-card';
import { mapState } from 'vuex';
export default {
	components: {
		ResultCard
	},
	computed: {
		...mapState('real-estate-data', ['relatedProperties'])
	}
};
</script>
<style lang="css" scoped>
@import '../../common/variables.pcss';

.related-properties {
	margin-bottom: 70px;
}

.related-properties >>> .favourites svg {
	width: 24px;
	height: 21px;
}

.related-properties >>> .favourites {
	top: 20px;
	right: 15px;
}

.related-properties__wrapper {
	justify-content: space-between;
	display: flex;
	flex-wrap: wrap;
	padding: 0 10px;

	@media (--desktop) {
		flex-wrap: nowrap;
		padding: 0;
	}
}

.related-properties__title {
	text-align: center;
	font-size: 42px;
	margin-bottom: 20px;
	line-height: 53px;
}
</style>